<div class="flex-stretch flexcol lg-sidebar-panel-scrollable lg-sidebar-panel-scrollable--full">
    <div
        lgScrollable
        [lgScrollableWrapper]="false"
        lgScrollbarClass="lg-scrollbar lg-scrollbar--sidebar"
        class="flex-stretch"
    >
        <ul class="lg-sidebar-menu">
            @if (_languageSwitchVisible) {
                <div class="lg-sidebar-menu__language-switch">
                    <div class="lg-sidebar-menu__language-switch__header">
                        {{ "FW._Language_switch.Language" | lgTranslate }}
                    </div>
                    <lg-language-switch></lg-language-switch>
                </div>
            }
            @for (navNode of _navigation; track navNode) {
                <lg-sidebar-menu-item
                    [currentUrl]="_currentUrl"
                    [navNode]="navNode"
                    (navigate)="_navigate($event)"
                ></lg-sidebar-menu-item>
            }
        </ul>
    </div>
</div>
